function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { defineComponent, computed, unref, withDirectives, openBlock, createElementBlock, normalizeClass, normalizeStyle, vShow, createCommentVNode, renderSlot } from 'vue';
import '../../../hooks/index.mjs';
import { carouselItemProps } from './carousel-item.mjs';
import { useCarouselItem } from './use-carousel-item.mjs';
import _export_sfc from '../../../_virtual/plugin-vue_export-helper.mjs';
import { useNamespace } from '../../../hooks/use-namespace/index.mjs';
const COMPONENT_NAME = "ElCarouselItem";
const __default__ = defineComponent({
  name: "ElCarouselItem"
});
const _sfc_main = /* @__PURE__ */defineComponent(_objectSpread(_objectSpread({}, __default__), {}, {
  props: carouselItemProps,
  setup(__props) {
    const props = __props;
    const ns = useNamespace("carousel");
    const _useCarouselItem = useCarouselItem(props, COMPONENT_NAME),
      carouselItemRef = _useCarouselItem.carouselItemRef,
      active = _useCarouselItem.active,
      animating = _useCarouselItem.animating,
      hover = _useCarouselItem.hover,
      inStage = _useCarouselItem.inStage,
      isVertical = _useCarouselItem.isVertical,
      translate = _useCarouselItem.translate,
      isCardType = _useCarouselItem.isCardType,
      scale = _useCarouselItem.scale,
      ready = _useCarouselItem.ready,
      handleItemClick = _useCarouselItem.handleItemClick;
    const itemStyle = computed(() => {
      const translateType = `translate${unref(isVertical) ? "Y" : "X"}`;
      const _translate = `${translateType}(${unref(translate)}px)`;
      const _scale = `scale(${unref(scale)})`;
      const transform = [_translate, _scale].join(" ");
      return {
        transform
      };
    });
    return (_ctx, _cache) => {
      return withDirectives((openBlock(), createElementBlock("div", {
        ref_key: "carouselItemRef",
        ref: carouselItemRef,
        class: normalizeClass([unref(ns).e("item"), unref(ns).is("active", unref(active)), unref(ns).is("in-stage", unref(inStage)), unref(ns).is("hover", unref(hover)), unref(ns).is("animating", unref(animating)), {
          [unref(ns).em("item", "card")]: unref(isCardType),
          [unref(ns).em("item", "card-vertical")]: unref(isCardType) && unref(isVertical)
        }]),
        style: normalizeStyle(unref(itemStyle)),
        onClick: _cache[0] || (_cache[0] = function () {
          return unref(handleItemClick) && unref(handleItemClick)(...arguments);
        })
      }, [unref(isCardType) ? withDirectives((openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(unref(ns).e("mask"))
      }, null, 2)), [[vShow, !unref(active)]]) : createCommentVNode("v-if", true), renderSlot(_ctx.$slots, "default")], 6)), [[vShow, unref(ready)]]);
    };
  }
}));
var CarouselItem = /* @__PURE__ */_export_sfc(_sfc_main, [["__file", "carousel-item.vue"]]);
export { CarouselItem as default };